import {createApp, defineComponent, h} from "vue"
import App from "./App.vue"
import { router } from "./router"
import { createPinia } from "pinia"
import { useUserStore } from "@/store"
import piniaPluginPersistedstate from "pinia-plugin-persistedstate"
import mitt from "mitt"
import { api } from "./api"
import { installBrowserErrors } from './monitoring/browserErrors'

import NewWindowApp from "./NewWindowApp.vue"
import WordCloud from "@/components/WordCloud.vue"
import {
  getLoginVerificationFailure,
} from "@/utils/authSession"
import {
  getLoginVerificationAction,
  SESSION_VERIFICATION_CONTEXT,
} from "@/utils/sessionVerification"
import { shouldPreventTextSelection } from "@/utils/textSelectionPolicy"

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export const eventBus = mitt()

// 조건에 따라 렌더링할 컴포넌트를 선택
const RootComponent = defineComponent({
  render() {
    if(window.location.pathname.includes('/newWindow')){
      return h(NewWindowApp)
    }
    return h(App);
  },
});

const app = createApp(RootComponent)
installBrowserErrors(app, 'bsedu-front')
app.use(pinia).use(router)

bootstrap()

async function bootstrap() {
  await verifyRestoredSession()
  app.mount("#app")
}

async function verifyRestoredSession() {
  const userStore = useUserStore()
  if (!userStore.accessToken) return

  try {
    const result = await api.login.isLoginUserVerify()
    handleLoginVerificationFailure(
      getLoginVerificationFailure(result),
      SESSION_VERIFICATION_CONTEXT.RESTORE,
    )
  } catch (error) {
    if (error.sessionUnauthorizedHandled) return
    const reason = getLoginVerificationFailure(null, error)
    if (reason) {
      handleLoginVerificationFailure(reason, SESSION_VERIFICATION_CONTEXT.RESTORE)
      return
    }
    console.log(error)
  }
}

function handleLoginVerificationFailure(reason, context) {
  const action = getLoginVerificationAction(reason, {
    context,
    currentPath: router.currentRoute.value.fullPath,
  })
  if (!action) return

  const userStore = useUserStore()
  userStore.clearAuthState()
  if (action.message) alert(action.message)
  router.replace(action.route)
}

//중복로그인방지
document.onclick = async function leftClick() {
  const target = window.event.srcElement;
  const userStore = useUserStore()
  if (target) {
    if(userStore.accessToken){
      try {
        const result = await api.login.isLoginUserVerify()
        handleLoginVerificationFailure(
          getLoginVerificationFailure(result),
          SESSION_VERIFICATION_CONTEXT.INTERACTION,
        )
      } catch(error) {
        if (error.sessionUnauthorizedHandled) return
        const reason = getLoginVerificationFailure(null, error)
        if (reason) {
          handleLoginVerificationFailure(reason, SESSION_VERIFICATION_CONTEXT.INTERACTION)
          return
        }
        console.log(error)
      }
    }
  }
};


document.addEventListener('DOMContentLoaded', (event) => {
  if(import.meta.env.VITE_ENV === 'production'){
    const userStore = useUserStore()

    // 마우스 우클릭 방지 (udgttl12@naver.com 계정은 허용)
    document.body.addEventListener('contextmenu', (e) => {
      const isCopyAllowed = userStore.user?.email === 'udgttl12@naver.com'
      if (!isCopyAllowed) {
        e.preventDefault();
      }
    }, false);

    // 마우스 드래그 방지 (테스트 페이지와 udgttl12@naver.com 계정은 허용)
    document.body.addEventListener('selectstart', (e) => {
      if (shouldPreventTextSelection(e.target, userStore.user?.email)) {
        e.preventDefault();
      }
    }, false);
  }
});
